module.exports = __webpack_public_path__ + "static/cherry-2fd1f7d92fc35176ba83a94aa8db029e.svg";